import RoomNameAndType from './RoomNameAndType';

export default RoomNameAndType;
